import React from 'react';
import SortDropdown from '@ifit/mp-sort-dropdown';
import TypeButtons from '@ifit/mp-type-buttons';
import { withTheme } from '@ifit/themes/withTheme';
import ViewAll from '@ifit/mp-view-all';
import NativeClick from '@ifit/mp-native-click';
import LineWrap from '@ifit/mp-line-wrap';
import './index.scss';

const ViewAllNative = ViewAll(NativeClick);

type Options = {
  value: string;
  text: string;
};

interface IProps extends Record<string, any> {
  title: string;
  maxCharacters?: number;
  deviceType?: string;
  hasMoreItems?: boolean;
  onSortingChanged?: (value: string) => void;
  onTypeOptionsChanged?: (value: string) => void;
  selectedSortOption?: number;
  selectedType?: string;
  sortOptions?: Options[];
  subtitle?: string;
  themeClass?: string;
  typeOptions?: Options[];
  viewAll?: React.ReactNode;
}

export const SectionHeader = (
  TitleWrapper: React.ComponentType = React.Fragment
) => {
  const sectionHeader = ({
    title,
    maxCharacters = 23,
    subtitle,
    selectedSortOption,
    sortOptions,
    onSortingChanged,
    themeClass,
    deviceType,
    typeOptions,
    onTypeOptionsChanged,
    selectedType,
    viewAll,
    hasMoreItems,
    ...props
  }: IProps) => {
    if (viewAll && !React.isValidElement(viewAll)) {
      viewAll = <ViewAllNative objectToSend={viewAll} />;
    }

    const hasTypeOptions = typeOptions ? 'section-header-types' : '';

    return (
      <div className={`section-header ${themeClass} ${hasTypeOptions}`}>
        <div className="section-left">
          <TitleWrapper {...props}>
            <div className="section-title">
              <h3>
                {deviceType === 'mobile' ? (
                  <LineWrap text={title} maxChar={maxCharacters} />
                ) : (
                  title
                )}
              </h3>

              {subtitle && <span className="subtitle">{subtitle}</span>}
            </div>
          </TitleWrapper>
        </div>

        {hasMoreItems && <div className="section-right">{viewAll}</div>}

        {typeOptions && (
          <TypeButtons
            onChange={onTypeOptionsChanged}
            options={typeOptions}
            deviceType={deviceType}
            themeClass={themeClass}
            selectedType={selectedType}
          ></TypeButtons>
        )}

        {sortOptions && (
          <SortDropdown
            selectedOption={selectedSortOption}
            options={sortOptions}
            onOptionChanged={onSortingChanged}
            deviceType={deviceType}
            coverWhenOpen={typeOptions && deviceType === 'mobile'}
            iconSize={typeOptions && deviceType === 'mobile' ? 24 : null}
          />
        )}
      </div>
    );
  };

  return withTheme(sectionHeader);
};

export default SectionHeader;
